import moment from 'moment'

export const peopleToOptions = ({ id, attributes: { full_name } }) => ({ value: id, name: full_name })

export const peopleToSelectOptions = ({ id, attributes: { full_name, born } }) => ({ value: id, label: `${full_name}${born ? (' (' + formatInputDate(born) + ')') : ''}` })

export const formatInputDate = (date) => (date && (new Date(date)).toLocaleDateString('en-CA'))

export const formatDatetime = (datetime) => (moment(datetime).format("YYYY-MM-DD HH:mm"))
